// src/lib/motion.js
// ----------------------------------------------------------------------------
// Central place to pull in Motion UI.
//
//   - `import 'motion-ui/dist/motion-ui.css'` — the precompiled stylesheet
//     that defines `.mui-enter` / `.mu-enter-active` transition states and the
//     named animations (`.fade-in`, `.slide-in-up`, `.slide-in-left`, …).
//     Importing it here (rather than in app.css) keeps the dependency explicit
//     and ensures the rules exist before any reveal class is applied.
//   - `import MotionUI from 'motion-ui/dist/motion-ui.js'` — the UMD factory
//     returns `{ animateIn, animateOut }` and resolves jQuery itself. We
//     re-export the object so callers can do `MotionUI.animateIn(el, 'fade-in')`.
//
// scroll-reveal.js is the primary consumer of the CSS classes; the JS API is
// used for explicit, code-driven animations (back-to-top, toasts, flourishes).
// ----------------------------------------------------------------------------
import 'motion-ui/dist/motion-ui.css';
import MotionUI from 'motion-ui/dist/motion-ui.js';

export default MotionUI;
